import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-recipes',
  templateUrl: './link-recipes.component.html',
  styleUrls: ['./link-recipes.component.scss']
})
export class LinkRecipesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
